import './App.css';
import {
    Anchor,
    Button,
    Card,
    Divider,
    Skeleton,
    Space,
} from 'antd';
import useSWR from 'swr';
import { Typography } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Loading from './Loading';

const { Title } = Typography;

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const MarshmallowCard = ({ data }: any) => {
    const n = useNavigate();
    return (
        <>
            <Card
                className="marshmallow-card"
                hoverable
                bordered={false}
                style={{ width: '100%' }}
                onClick={() => n(`/marshmallow/${data.id}`)}>
                <Space style={{ width: '100%' }}>
                    {data.title}
                </Space>
            </Card>
        </>
    );
};

const Marshmallow = () => {
    const n = useNavigate();
    const { data, error, isLoading } = useSWR(
        'https://api.lynne.com.cn/marshmallow/list',
        fetcher
    );
    if (isLoading || data === undefined) return <Loading />;
    if (error) return <div>居然加载失败了喵！</div>;
    const marshmallows = [];
    const marshmallowCategories: any[] = [];
    const anchors = [];
    for (let i = 0; i < data.data.length; i++) {
        if (marshmallowCategories.indexOf(data.data[i].category) === -1) {
            marshmallowCategories.push(data.data[i].category);
            marshmallows.push({
                categoryId: data.data[i].category,
                category: data.data[i].name,
                data: [data.data[i]],
            });
            anchors.push({
                key: `part${data.data[i].category}`,
                href: `#part${data.data[i].category}`,
                title: data.data[i].name,
            });
        } else {
            marshmallows[marshmallowCategories.indexOf(data.data[i].category)].data.push(data.data[i]);
        }
    }
    // 渲染数据
    return (
        <>
            <Helmet>
                <title>棉花糖 - 玲奈的dd站</title>
                <meta
                    name="description"
                    content="这里是棉花糖列表，有来自小狐凃的投稿哦~"
                    />  
            </Helmet>
            <Space>
                <Button type='primary' onClick={() => n('/marshmallow/create')}>
                    我要投稿！
                </Button>
                <Button type='primary' onClick={() => n('/dashboard')}>
                    投稿管理
                </Button>
            </Space>
            <Divider />
            <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                公开の棉花糖！
            </Title>
            <Space
                direction='vertical'
                size={'middle'}
                style={{ width: '100%' }}>
                <Anchor
                    className="anchor"
                    targetOffset={25}
                    direction='horizontal'
                    items={anchors}
                    style={{
                        padding: '2px 15px',
                        borderRadius: '8px',
                    }}
                />
                {marshmallows.map(marshmallow => {
                    return (
                        <div
                            id={`part${marshmallow.categoryId}`}
                            key={marshmallow.category}>
                            <Card
                                title={marshmallow.category}
                                bordered={false}
                                style={{ width: '100%' }}>
                                <Space
                                    direction='vertical'
                                    size={'middle'}
                                    style={{ width: '100%' }}>
                                    {marshmallow.data.map(item => {
                                        return (
                                            <MarshmallowCard
                                                key={item.id}
                                                data={item}
                                            />
                                        );
                                    })}
                                </Space>
                            </Card>
                        </div>
                    );
                })}
            </Space>
        </>
    );
};

export default Marshmallow;
